import { render } from "./AwardsConfig.vue?vue&type=template&id=e2e5f7b4"
import script from "./AwardsConfig.vue?vue&type=script&lang=js"
export * from "./AwardsConfig.vue?vue&type=script&lang=js"

import "./AwardsConfig.vue?vue&type=style&index=0&id=e2e5f7b4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__